module.exports = __webpack_public_path__ + "media/src/images/arrow_down-94252226cb18b48b82128a173b3d492e.png";